import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { BaseBasicDialog } from '../model';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent extends BaseBasicDialog {

  constructor(
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    protected _fuseTranslationLoaderService: FuseTranslationLoaderService,
    protected _fuseProgressBarService: FuseProgressBarService
  ) {
    super(dialogRef, _fuseTranslationLoaderService, _fuseProgressBarService);
  }
}
